import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_afmk8knmga: FaireBrandEntity = {
  token: "b_afmk8knmga",
  type: "brand",
  name: "Urlazh",
  avatarUrl:
    "https://cdn.faire.com/fastly/dd6f7c2f2568f411b4cd80cbee1c0c4cbbf297d054a450fb390361072bc620f1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1ac565601f7cf769f7de4b9fb452fe50afbfc34fa9b9cd92b56e7beaf05a971b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dd6f7c2f2568f411b4cd80cbee1c0c4cbbf297d054a450fb390361072bc620f1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ac565601f7cf769f7de4b9fb452fe50afbfc34fa9b9cd92b56e7beaf05a971b.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 3,
  isInsider: false,
  description:
    'Clothes With Personality!\n\n"URLAZH" pronounced /u:la:/ is a dynamic contemporary ready-to-wear brand that exudes personality through contemporary designs featuring the concept of "easy, fun and comfortable". High-quality materials, exquisite workmanship, tailoring, vibrant color and artistic patterns are characteristic of URLAZH.  \n\nCreate an enjoyable lifestyle that lives without age - the URLAZH GIRL. Advocating the coexistence of a collection of multi-style product lines to provide customers with more possibilities. With unique and characterful design, URLAZH gives customers a means to express their individual style.',
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:44.456Z",
    importedBy: "entity-db-cli",
  },
};
